import script from "./PreviousLoginModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviousLoginModal.vue?vue&type=script&setup=true&lang=ts"

import "./PreviousLoginModal.vue?vue&type=style&index=0&id=56328d9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56328d9a"]])

export default __exports__